import { formatUnits } from '@ethersproject/units'

var formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 3 })

var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 12,
})

export const stakingMapping = {
    //https://www.reddit.com/r/IceDaoFinance/comments/refcyp/ice_dao_info/
    // GLA as Staked ICE
    '0x4b993a3544b01946c474bcb82fd483a5cff32a46': {
        contract: '0x9235b893a3e61a14b2d02a91ec1394fbf411689e',
        name: 'ICE',
    },
    // sMAG / MAG
    '0x1eda3ef892ab5521f4fcd5cee4825f57b48ed961': {
        contract: '0x1d60109178c48e4a937d8ab71699d8ebb6f7c5de',
        name: 'MAG',
    },
}

export const getLGFPortfolioNumber = response => {
    var number = 0
    response.data.data.items.map(item => {
        if (item.holdings[0].close.balance > 0) {
            number += 1
        }
        return null
    })
    return number
}

export const getLGFPortfolioPrice = response => {
    console.log('response ', response)
    var price = 0
    response.data.data.items.map(item => {
        if (item.holdings[0].close.balance > 0) {
            var stakingPrice = 0
            if (stakingMapping[item.contract_address]) {
                stakingPrice = getItemPortfolioPrice(
                    response,
                    stakingMapping[item.contract_address].contract
                )
            }
            price += parseFloat(
                stakingPrice !== 0
                    ? stakingPrice *
                          formatUnits(
                              item.holdings[0].close.balance,
                              item.contract_decimals
                          )
                    : item.holdings[0].close.quote
                    ? item.holdings[0].close.quote
                    : 0
            )
        }
        return null
    })
    return price
}

export const getItemPortfolioPrice = (response, contract) => {
    var price = 0
    response.data.data.items.map(item => {
        if (item.contract_address === contract) {
            price += parseFloat(
                item.holdings[0].quote_rate ? item.holdings[0].quote_rate : 0
            )
        }
        return null
    })
    return price
}

export const getLGFPortfolioDataTable = response => {
    var datatable = []
    response.data.data.items.map(item => {
        if (item.holdings[0].close.balance > 0) {
            // IF Staking replace by Token value
            var stakingName = ''
            var stakingPrice = ''
            if (stakingMapping[item.contract_address]) {
                stakingName = stakingMapping[item.contract_address].name
                stakingPrice = getItemPortfolioPrice(
                    response,
                    stakingMapping[item.contract_address].contract
                )
            }
            datatable.push([
                item.contract_name +
                    ' (' +
                    item.contract_ticker_symbol +
                    (stakingName !== '' ? ' *Staked ' + stakingName : '') +
                    ')',
                item.holdings[0].quote_rate
                    ? formatterUS.format(
                          parseFloat(item.holdings[0].quote_rate)
                      )
                    : stakingPrice
                    ? formatterUS.format(parseFloat(stakingPrice))
                    : '#N/A',
                formatter.format(
                    parseFloat(
                        formatUnits(
                            item.holdings[0].close.balance,
                            item.contract_decimals
                        )
                    )
                ) +
                    ' ' +
                    item.contract_ticker_symbol,
                item.holdings[0].close.quote
                    ? formatterUS.format(
                          parseFloat(item.holdings[0].close.quote).toFixed(2)
                      )
                    : stakingPrice
                    ? formatterUS.format(
                          parseFloat(
                              stakingPrice *
                                  formatUnits(
                                      item.holdings[0].close.balance,
                                      item.contract_decimals
                                  )
                          ).toFixed(2)
                      )
                    : '#N/A',
            ])
        }
        return null
    })
    return datatable
}

export const getItemBalancePrice = (response, contract) => {
    var price = 0
    response.data.data.data.items.map(item => {
        if (item.contract_address === contract) {
            price += parseFloat(item.quote_rate ? item.quote_rate : 0)
        }
        return null
    })
    return price
}

export const getBalancePrice = response => {
    var value = 0
    response.data.data.data.items.map(item => {
        var stakingPrice = 0
        if (stakingMapping[item.contract_address]) {
            stakingPrice = getItemBalancePrice(
                response,
                stakingMapping[item.contract_address].contract
            )
        }

        value +=
            stakingPrice > 0
                ? stakingPrice *
                  formatUnits(item.balance, item.contract_decimals)
                : item.quote

        return null
    })
    return value
}
